module.exports = __webpack_public_path__ + "static/img/zf4.8b2c607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zf4.png
// module id = Wrgs
// module chunks = 1